<script setup>
// X213: "Box league · Squash · 12 players" / "… · Next cycle starts Mon 3 Nov" (utils/competitionCard.js).
import {computed} from 'vue';
import ClickableCell from '@/components/lists/ClickableCell';
import {leagueCardLine} from '~/utils/competitionCard';
// Props
const props = defineProps({
  league: {
    type: Object,
    default: () => null
  },
  timeZone: {
    type: String,
    default: null
  }
});
const subtitle = computed(() => leagueCardLine(props.league, {timeZone: props.timeZone}));
</script>

<template>
  <clickable-cell
      icon="mdi-table"
      tone="league"
      class="mb-3"
      :to="{ name: 'LeagueDetail', params: { leagueId: props.league.id } }"
      :title="league.name"
      :subtitle="subtitle"
      subtitle-one-line
  />
</template>
